import {Platform, StyleSheet} from 'react-native';
import {MODAL_WIDTH} from './constants';
import Styles from '../../../Styles';

export const helpScreenStyles = StyleSheet.create({
  modalMain: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContainer: {
    minHeight: Platform.OS === 'ios' ? 270 : 280,
    width: MODAL_WIDTH,
    backgroundColor: Styles.white,
    borderRadius: Styles.Spacing.m3,
    paddingHorizontal: 25,
  },
  closeModalTitleContainer: {
    justifyContent: 'flex-end',
    position: 'absolute',
    right: 15,
    top: 10,
    zIndex: 999999,
  },
  modalContentContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
  },
  template1Style: {
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
  },
  answersTxt: {
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    color: Styles.Colors.PayNew.primary01,
  },
});
